function isEmptyPutDataFieldValue(field: unknown): boolean {
  if (field == null) return true
  if (typeof field === 'object' && field !== null && 'value' in field) {
    const value = (field as { value: unknown }).value
    return value == null || value === ''
  }
  return field === ''
}

/**
 * Дополняет поля, собранные putData(name), из pageData/jsResult и forms registry.
 */
export function mergePutDataCollectedFields(
  collectedFields: Record<string, unknown>,
  requestedName: string,
  incomingFields: Record<string, unknown>,
  formsRegistryField?: unknown,
): Record<string, unknown> {
  const requested = typeof requestedName === 'string' ? requestedName.trim() : ''
  const incomingHasRequested =
    requested !== '' && Object.prototype.hasOwnProperty.call(incomingFields, requested)

  if (Object.keys(collectedFields).length === 0) {
    if (incomingHasRequested) {
      return { [requested]: incomingFields[requested] }
    }
    if (requested !== '' && formsRegistryField !== undefined) {
      return { [requested]: formsRegistryField }
    }
    return incomingFields
  }

  if (incomingHasRequested) {
    const hasCollected = Object.prototype.hasOwnProperty.call(collectedFields, requested)
    const collectedValue = hasCollected ? collectedFields[requested] : undefined
    if (!hasCollected || isEmptyPutDataFieldValue(collectedValue)) {
      return {
        ...collectedFields,
        [requested]: incomingFields[requested],
      }
    }
  }

  if (
    requested !== '' &&
    !Object.prototype.hasOwnProperty.call(collectedFields, requested) &&
    formsRegistryField !== undefined
  ) {
    return {
      ...collectedFields,
      [requested]: formsRegistryField,
    }
  }

  return collectedFields
}
